import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CreaEsperienza from './pages/CreaEsperienza';
import Bacheca from './pages/Bacheca';
import Profilo from './pages/Profilo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import EliminaDati from './pages/EliminaDati';
import TerminiUso from './pages/TerminiUso';
import Trasporto from './pages/Trasporto';
import ComeFunziona from './pages/ComeFunziona';
import Alloggio from './pages/Alloggio';
import Attivita from './pages/Attivita';
import Servizi from './pages/Servizi';
import Pacchetto from './pages/Pacchetto';
import PacchettoDemo from './pages/PacchettoDemo';
import Impostazioni from './pages/Impostazioni';

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) navigate('/login');
      else setChecking(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') navigate('/login');
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  if (checking) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f7fa' }}>
      <p style={{ color: '#6b7280', fontSize: '15px', fontFamily: 'sans-serif' }}>Caricamento...</p>
    </div>
  );

  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/crea" element={<ProtectedRoute><CreaEsperienza /></ProtectedRoute>} />
        <Route path="/bacheca" element={<Bacheca />} />
        <Route path="/profilo" element={<ProtectedRoute><Profilo /></ProtectedRoute>} />
        <Route path="/impostazioni" element={<ProtectedRoute><Impostazioni /></ProtectedRoute>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/elimina-dati" element={<EliminaDati />} />
        <Route path="/termini" element={<TerminiUso />} />
        <Route path="/trasporto" element={<Trasporto />} />
        <Route path="/come-funziona" element={<ComeFunziona />} />
        <Route path="/alloggio" element={<Alloggio />} />
        <Route path="/attivita" element={<Attivita />} />
        <Route path="/servizi" element={<Servizi />} />
        <Route path="/pacchetto/:slug" element={<Pacchetto />} />
        <Route path="/demo" element={<PacchettoDemo />} />
      </Routes>
    </Router>
  );
}

export default App;